import PropTypes from 'prop-types';
import EditIcon from '@/assets/requirement/editRequirement.svg';
import './RequirementCard.css';

const RequirementCard = ({ requirement, onEdit, onDelete }) => {
  const handleDelete = () => {
    onDelete(requirement.id);
  };

  return (
    <div className="requirement-card">
      <div className="requirement-card__header">
        <div className="requirement-card__title-wrapper">
          <h3 className="requirement-card__title">
            {requirement.category?.name || 'Category'}
          </h3>
        </div>
        <div className="requirement-card__actions">
          <button
            className="requirement-card__edit-btn" 
            onClick={() => onEdit(requirement)}
            aria-label="Edit requirement"
          >
            <img src={EditIcon} alt="Edit" className="requirement-card__edit-icon" />
          </button>
          <button 
            className="requirement-card__delete-btn" 
            onClick={handleDelete}
            aria-label="Delete requirement"
            title="Delete"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      
      <div className="requirement-card__body">
        {requirement.quantity_range && (
          <div className="requirement-card__row">
            <span className="requirement-card__label">Quantity Range</span>
            <span className="requirement-card__value">{requirement.quantity_range}</span>
          </div>
        )}
        
        {requirement.industry && (
          <div className="requirement-card__row">
            <span className="requirement-card__label">Industry</span>
            <span className="requirement-card__value">{requirement.industry.name}</span>
          </div>
        )}
        
        {requirement.region_city && (
          <div className="requirement-card__row">
            <span className="requirement-card__label">Regions</span>
            <span className="requirement-card__value">{requirement.region_city.name}</span>
          </div>
        )}
        
        {requirement.space_available && (
          <div className="requirement-card__row">
            <span className="requirement-card__label">Space Avail</span>
            <span className="requirement-card__value">{requirement.space_available}</span>
          </div>
        )}
      </div>
    </div>
  );
};

RequirementCard.propTypes = {
  requirement: PropTypes.shape({
    id: PropTypes.number,
    category: PropTypes.shape({
      name: PropTypes.string,
    }),
    quantity_range: PropTypes.string,
    industry: PropTypes.shape({
      name: PropTypes.string,
    }),
    region_city: PropTypes.shape({
      name: PropTypes.string,
    }),
    space_available: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RequirementCard;
